import React from "react";
import { useState, useEffect, useRef } from "react";
import { useReactMediaRecorder } from "react-media-recorder-2";
import { ScreenCapture } from "react-screen-capture";
import FeedbackReport from "./FeedbackReport/FeedbackReport";
import ScreenRecording from "./ScreenRecording/ScreenRecording";
import html2canvas from "html2canvas";
import { isUserLoggedIn } from "redux/reducers/loggedInUser";
import { useSelector } from "react-redux";
import * as rrweb from 'rrweb';
import axios from "axios";
import { JIRA_URL } from 'configs/AppConfig';

let events = [];
const eventsMatrix = [[]];
var networksLogs ;
let data = window.navigator.userAgent.toLowerCase();

let isCheck = /mobile|android|iphone|ipod|blackberry|iemobile|opera mini/i.test(
  data
);

// import "./jira_styles.css";

const JiraReportComponent = ({ children, projectKey }) => {
  const isLoggedIn = useSelector(isUserLoggedIn);
  const inputFileRef = useRef(null);
  const [mediaBlobUrl, setMediaBlobUrl] = useState("");
  const {
    status,
    startRecording,
    stopRecording,
    mediaBlobUrl: currentMediaBlobUrl,
  } = useReactMediaRecorder({
    screen: isCheck ? false : true,
    audio: false,
    video: true,
    blobPropertyBag: {
      type: "video/mp4",
    },
  });
  const [screenCapture, setScreenCapture] = useState("");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [issueTitle, setIssueTitle] = useState("");
  const [issueDescription, setIssueDescription] = useState("");
  const [showRecorder, setShowRecorder] = useState(false);
  const [successJiraMessage, setSuccessJiraMessage] = useState(false);
  const [attachmentFile, setAttachmentFile] = useState(null);
  const [popupType, setPopupType] = useState(0);
  const [submitLoader, setSubmitLoader] = useState(false);

  //screen capture bug fix
  const [name, setName] = useState("GAMO");
  // const [screenCapture, setScreenCapture] = useState('');
  const [on, setOn] = useState(false);
  const [startX, setStartX] = useState(0);
  const [startY, setStartY] = useState(0);
  const [endX, setEndX] = useState(0);
  const [endY, setEndY] = useState(0);
  const [crossHairsTop, setCrossHairsTop] = useState(0);
  const [crossHairsLeft, setCrossHairsLeft] = useState(0);
  const [isMouseDown, setIsMouseDown] = useState(false);
  const [windowWidth, setWindowWidth] = useState(0);
  const [windowHeight, setWindowHeight] = useState(0);
  const [borderWidth, setBorderWidth] = useState(0);
  const [cropPositionTop, setCropPositionTop] = useState(0);
  const [cropPositionLeft, setCropPositionLeft] = useState(0);
  const [cropWidth, setCropWidth] = useState(0);
  const [cropHeight, setCropHeight] = useState(0);
  const [imageURL, setImageURL] = useState("");
  const [scrollX, setScrollX] = useState(0);
  const [scrollY, setScrollY] = useState(0);



  const [data, setData] = useState([]);


  useEffect(() => {
    // Call the API and set the data in the state
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await fetch("https://dummyjson.com/products");
      const jsonData = await response.json();
      setData(jsonData.products.slice(0, 2));
    } catch (error) {
      console.log("Error fetching data:", error);
    }
  };

  useEffect(() => {
    handleWindowResize();
    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  const handleWindowResize = () => {
    // const windowWidth =
    //   window.innerWidth ||
    //   document.documentElement.clientWidth ||
    //   document.body.clientWidth;
    // const windowHeight =
    //   window.innerHeight ||
    //   document.documentElement.clientHeight ||
    //   document.body.clientHeight;

    const windowWidth =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    const windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    const scrollX =
      window.scrollX ||
      window.pageXOffset ||
      document.documentElement.scrollLeft;
    const scrollY =
      window.scrollY ||
      window.pageYOffset ||
      document.documentElement.scrollTop;

    setScrollX(scrollX);
    setScrollY(scrollY);
    setWindowWidth(windowWidth);
    setWindowHeight(windowHeight);
  };

  const onClickCapture = () => {
    html2canvas(document.body).then(function (canvas) {
      document.body.appendChild(canvas);
    });
  };

  const handleMouseMove = (e) => {
    e.preventDefault();

    // const { isMouseDown, windowWidth, windowHeight, startX, startY, borderWidth } = this.state;

    const scrollX = window.scrollX || window.pageXOffset;
    const scrollY = window.scrollY || window.pageYOffset;

    const endX = e.clientX + scrollX; // Adjusted X coordinate
    const endY = e.clientY + scrollY; // Adjusted Y coordinate

    let newCropPositionTop = startY;
    let newCropPositionLeft = startX;
    const newEndX = e.clientX;
    const newEndY = e.clientY;
    const isStartTop = newEndY >= startY;
    const isStartBottom = newEndY <= startY;
    const isStartLeft = newEndX >= startX;
    const isStartRight = newEndX <= startX;
    const isStartTopLeft = isStartTop && isStartLeft;
    const isStartTopRight = isStartTop && isStartRight;
    const isStartBottomLeft = isStartBottom && isStartLeft;
    const isStartBottomRight = isStartBottom && isStartRight;
    let newBorderWidth = borderWidth;
    let newCropWidth = 0;
    let newCropHeight = 0;

    if (isMouseDown) {
      if (isStartTopLeft) {
        newBorderWidth = `${startY}px ${windowWidth - newEndX}px ${
          windowHeight - newEndY
        }px ${startX}px`;
        newCropWidth = newEndX - startX;
        newCropHeight = newEndY - startY;
      }

      if (isStartTopRight) {
        newBorderWidth = `${startY}px ${windowWidth - startX}px ${
          windowHeight - newEndY
        }px ${newEndX}px`;
        newCropWidth = startX - newEndX;
        newCropHeight = newEndY - startY;
        newCropPositionLeft = newEndX;
      }

      if (isStartBottomLeft) {
        newBorderWidth = `${newEndY}px ${windowWidth - newEndX}px ${
          windowHeight - startY
        }px ${startX}px`;
        newCropWidth = newEndX - startX;
        newCropHeight = startY - newEndY;
        newCropPositionTop = newEndY;
      }

      if (isStartBottomRight) {
        newBorderWidth = `${newEndY}px ${windowWidth - startX}px ${
          windowHeight - startY
        }px ${newEndX}px`;
        newCropWidth = startX - newEndX;
        newCropHeight = startY - newEndY;
        newCropPositionLeft = newEndX;
        newCropPositionTop = newEndY;
      }
    }


    setCrossHairsTop(e.clientY);
    setCrossHairsLeft(e.clientX);
    setBorderWidth(newBorderWidth);
    setCropWidth(newCropWidth);
    setCropHeight(newCropHeight);
    setCropPositionTop(newCropPositionTop);
    setCropPositionLeft(newCropPositionLeft);
  };

  const handleMouseDown = (e) => {
    e.preventDefault();
    const newStartX = e.clientX;
    const newStartY = e.clientY;

    setStartX(newStartX);
    setStartY(newStartY);
    setCropPositionTop(newStartY);
    setCropPositionLeft(newStartX);
    setIsMouseDown(true);
    setBorderWidth(`${windowWidth}px ${windowHeight}px`);
  };

  const handleMouseUp = (e) => {
    e.preventDefault();
    handleClickTakeScreenShot();
    setOn(false);
    setIsMouseDown(false);
    setBorderWidth(0);
  };

  const handStartCapture = () => {
    setOn(true);
  };

  const handleClickTakeScreenShot = () => {
    // const { cropPositionTop, cropPositionLeft, cropWidth, cropHeight } = state;

    if (on) {
      const elementToCapture = document.getElementById("element-id-to-capture");

      if (elementToCapture) {
        const { innerWidth, innerHeight, scrollX, scrollY } = window;

        const {width, height} = elementToCapture.getBoundingClientRect();



        html2canvas(document.body, {
          width: innerWidth,
          height: innerHeight,
          x: scrollX,
          y: scrollY,
        }).then((canvas) => {
          // let croppedCanvas = document.createElement('canvas')
          // let croppedCanvasContext = croppedCanvas.getContext('2d')
    
          // croppedCanvas.width = cropWidth;
          // croppedCanvas.height = cropHeight;

    
          // croppedCanvasContext.drawImage(canvas, cropPositionLeft, cropPositionTop, 1100, 400, 0, 0, 1100, 400);


          // console.log('canva', canvas)
          // console.log('croppedcanva', croppedCanvas)

          // var a = document.createElement("a");
          // a.href = canvas.toDataURL("image/png");
          // a.download = "somefilename.png";
          // a.click();

          window.removeEventListener("resize", handleWindowResize);
          window.removeEventListener("mousemove", handleMouseMove);
          window.removeEventListener("mouseup", handleMouseUp);
          window.removeEventListener("mousemove", handleMouseMove);

          // onEndCapture(croppedCanvas.toDataURL());
          handleScreenCapture(canvas.toDataURL());
        });
      }
    }
  };

  useEffect(() => {
    const isUserFound = localStorage.getItem("loggedIN");
    if (isUserFound) {
      setEmail(isUserFound);
    } else {
      setEmail("");
    }
  }, [isLoggedIn]);

  function getBrowserInfo(userAgent) {
    // Define regular expressions to match popular browsers
    const chromeRegex = /Chrome\/([\d.]+)/;
    const firefoxRegex = /Firefox\/([\d.]+)/;
    const edgeRegex = /Edg\/([\d.]+)/;
    const safariRegex = /Safari\/([\d.]+)/;

    if (userAgent.match(chromeRegex)) {
      return "Google Chrome";
    } else if (userAgent.match(firefoxRegex)) {
      return "Mozilla Firefox";
    } else if (userAgent.match(edgeRegex)) {
      return "Microsoft Edge";
    } else if (userAgent.match(safariRegex) && !userAgent.match(chromeRegex)) {
      return "Safari";
    } else {
      return "Unknown Browser";
    }
  }

  const handleStartRecording = () => {
    setMediaBlobUrl("");
    startRecording();
  };

  const handleStopRecording = () => {
    stopRecording();
  };

  const handleReset = () => {
    setMediaBlobUrl("");
  };

  // Update mediaBlobUrl whenever currentMediaBlobUrl changes
  useEffect(() => {
    if (currentMediaBlobUrl) {
      setMediaBlobUrl(currentMediaBlobUrl);
    }
  }, [currentMediaBlobUrl]);

  const handleAttachmentChange = (e) => {
    if (e.target.files) {
      const file = e.target.files[0];
      const maxSize = 10 * 1024 * 1024; // Maximum size in bytes (e.g., 5MB)

      if (file.size > maxSize) {
        alert("File size exceeds the maximum limit!");
        // Reset the file input if needed
        e.target.value = null;
        return;
      } else {
        setAttachmentFile(e.target.files[0]);
      }
    }
  };

  const handleRemoveAttachmentFile = () => {
    if (inputFileRef.current) {
      inputFileRef.current.value = "";
    }

    setAttachmentFile(null);
  };
  useEffect(() => {
    const fetchNetworkData = () => {
      networksLogs=[]
      const entries = window.performance.getEntries();
      const networkEntries = entries.filter(entry => entry.entryType === 'resource');
    const networkEntriestwo = networkEntries?.filter(entry => entry.initiatorType=== "xmlhttprequest" &&entry.responseStatus !== 200)?.map(entry => {
      return { name: entry.name,  responseStatus:entry.responseStatus,initiatorType:entry.initiatorType };
    });
    networksLogs=networkEntriestwo
    };
 
    // Fetch network data when the component mounts
    fetchNetworkData();
 
    // Optionally, you can set up an interval to periodically fetch network data
    const interval = setInterval(fetchNetworkData, 5000 ); // Fetch every 5 minutes
 
    rrweb.record({
      emit(event, isCheckout) {
        // isCheckout is a flag to tell you the events has been checkout
        if (isCheckout) {
          eventsMatrix.push([]);
        }
        const lastEvents = eventsMatrix[eventsMatrix.length - 1];
        lastEvents.push(event);
        if (eventsMatrix.length > 5) {
          eventsMatrix.shift(); // Remove the first element
        }
      },
      plugins: [
        rrweb.getRecordConsolePlugin({
          level: ['error'],
          lengthThreshold: 10000,
          stringifyOptions: {
            stringLengthLimit: 1000,
            numOfKeysLimit: 100,
            depthOfLimit: 1,
          },
          logger: window.console,
        }),
      ],
      checkoutEveryNms: 1 * 60 * 1000, // checkout every 5 minutes
    });
    return () => clearInterval(interval);
  }, []);
  // useEffect(() => {
  //   rrweb.record({
  //     emit(event) {
  //       const defaultLog = console.log["__rrweb_original__"]
  //         ? console.log["__rrweb_original__"]
  //         : console.log;
  //       // defaultLog(event);
  //       events.push(event);
  //     },
  //     plugins: [
  //       rrweb.getRecordConsolePlugin({
  //         level: ["info", "log", "warn", "error"],
  //         lengthThreshold: 10000,
  //         stringifyOptions: {
  //           stringLengthLimit: 1000,
  //           numOfKeysLimit: 100,
  //           depthOfLimit: 1,
  //         },
  //         logger: window.console,
  //       }),
  //     ],
  //   });

  //   const clearEvents = setInterval(() => {
  //     events = [];
  //   }, 5 * 60 * 1000);

  //   return () => {
  //     clearInterval(clearEvents);
  //   };
  // }, []);

  const captureScreenshot = () => {
    const element = document.getElementById("root"); // Replace 'root' with the ID of your root element or any other element you want to capture

    html2canvas(element).then((canvas) => {
      const screenshot = canvas.toDataURL("image/png");
      downloadScreenshot(screenshot);
    });
  };

  const downloadScreenshot = (screenshot) => {
    const link = document.createElement("a");
    link.href = screenshot;
    link.download = "screenshot.png";
    link.target = "_blank";
    link.click();
  };

  // useEffect(() => {
  // 	setMediaBlobUrl(currentMediaBlobUrl);
  // }, [currentMediaBlobUrl]);

  const onPopupToggle = () => {
    if (isPopupOpen === true) {
      onClosePopup();
    }
    setIsPopupOpen(!isPopupOpen);
  };

  const onClosePopup = () => {
    setIsPopupOpen(false);
    setShowRecorder(false);
    setScreenCapture("");
    setAttachmentFile(null);
    setIssueTitle("");
    setIssueDescription("");
    // setEmail('');
    setMediaBlobUrl("");
    setPopupType(0);
    setSuccessJiraMessage("");
  };

  const handleScreenshot = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  const handleClearScreenshot = () => {
    setScreenCapture("");
  };

  const handleScreenCapture = (screenCapture) => {
    const d = dataURLtoFile(screenCapture, "screenshott");
    setScreenCapture(d);
    setIsPopupOpen(!isPopupOpen);
    setOn(false);
  };

  function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[arr.length - 1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  const handleSave = () => {
    // const screenCaptureSource = this.state.screenCapture;
    // const downloadLink = document.createElement('a');
    // const fileName = 'react-screen-capture.png';
    // downloadLink.href = screenCaptureSource;
    // downloadLink.download = fileName;
    // downloadLink.click();
  };

  const resetMediaBlobUrl = () => {
    // setMediaBlobUrl(undefined);
  };


  const getTicketType = (type) => {
    if (type === 1) {
      return "Bug";
    } else if (type === 2) {
      return "Story";
    } else if (type === 3) {
      return "Feedback";
    }
  };

  const createJiraIssue = async (e) => {
    e.preventDefault();
    setSubmitLoader(true);


    let eevents = [];
    const len = eventsMatrix.length;
    if (len > 4) {
      console.log("above 4");
      eevents = eventsMatrix[len - 5]
        .concat(eventsMatrix[len - 4])
        .concat(eventsMatrix[len - 3])
        .concat(eventsMatrix[len - 2])
        .concat(eventsMatrix[len - 1]);
    } else {
      eevents = eventsMatrix.reduce((acc, curr) => acc.concat(curr), []);
    }
    let mergedArray;
    if(networksLogs.length>0){
     mergedArray = eevents.concat(networksLogs);
    }
console.log(mergedArray);

    const body = JSON.stringify(mergedArray);

    const jsonContent = JSON.stringify(eevents);
    const blob = new Blob([jsonContent], { type: 'application/json' });




    let params = {
      projectName: projectKey,
      email: email,
      title: issueTitle,
      description: issueDescription,
      ticketType: getTicketType(popupType),
      pageUrl: `${window.location.href}`,
      screenResolution: `${window.screen.width}x${window.screen.height}`,
      browser: getBrowserInfo(navigator.userAgent),
      networkSpeed: `${navigator.connection.downlink}mbps`,
      // events: JSON.stringify(eevents),
    };

    const formData = new FormData();
    const sessionFormData = new FormData()

    if (mediaBlobUrl) {
      const mediaBlob = await fetch(mediaBlobUrl).then((response) =>
        response.blob()
      );
      const filename = "test.mp4";
      const videoFile = new File([mediaBlob], filename, {
        type: mediaBlob.type,
      });
      if (videoFile instanceof File) {
        formData.append("uploadFiles", mediaBlob);
      }
    }

    
    for (const [key, value] of Object.entries(params)) {
      formData.append(key, value);
    }
    if (attachmentFile instanceof File) {
      formData.append("uploadFiles", attachmentFile);
    }
    if (screenCapture instanceof File) {
      formData.append("uploadFiles", screenCapture);
    }
    for (const [key, value] of formData.entries()) {
    }
    if(blob instanceof File) {
    }
    sessionFormData.append('sessionFile', blob, 'data.json');
    
    try {
      const res = await axios.post(
        `${JIRA_URL}/upload-session-file`,
        sessionFormData
      );

      if(res.data.statusValue === 200){
        try {
          formData.append('events',res.data.filePath)
    
          const response = await axios.post(
            `${JIRA_URL}/create-jira-ticket`,
            formData
          );

          // console.log("Issue created successfully:", response.data);
          setSuccessJiraMessage(true);
          setPopupType(4);
          setSubmitLoader(false);
        } catch (error) {
          console.error("Error creating Jira issue:", error);
        }
      }

      // console.log('res session', res)
    } catch(error) {
      console.log('error in posting session data')
    }


  };


  const onStartCapture = () => {
    setOn(true);
  };

  return (
    <div
      onMouseMove={on ? handleMouseMove : null}
      onMouseDown={on ? handleMouseDown : null}
      onMouseUp={on ? handleMouseUp : null}
      id="element-id-to-capture"
    >
      <>
        {children}
        <FeedbackReport
          onStartCapture={onStartCapture}
          screenCapture={screenCapture}
          handleScreenshot={handleScreenshot}
          onPopupToggle={onPopupToggle}
          isPopupOpen={isPopupOpen}
          setIsPopupOpen={setIsPopupOpen}
          issueTitle={issueTitle}
          setIssueTitle={setIssueTitle}
          handleClearScreenshot={handleClearScreenshot}
          showRecorder={showRecorder}
          setShowRecorder={setShowRecorder}
          issueDescription={issueDescription}
          setIssueDescription={setIssueDescription}
          mediaBlobUrl={mediaBlobUrl}
          status={status}
          resetMediaBlobUrl={resetMediaBlobUrl}
          projectKey={projectKey}
          successJiraMessage={successJiraMessage}
          setSuccessJiraMessage={setSuccessJiraMessage}
          createJiraIssue={createJiraIssue}
          handleAttachmentChange={handleAttachmentChange}
          attachmentFile={attachmentFile}
          setAttachmentFile={setAttachmentFile}
          email={email}
          setEmail={setEmail}
          handleReset={handleReset}
          onClosePopup={onClosePopup}
          popupType={popupType}
          setPopupType={setPopupType}
          handleRemoveAttachmentFile={handleRemoveAttachmentFile}
          inputFileRef={inputFileRef}
          submitLoader={submitLoader}
          setSubmitLoader={setSubmitLoader}
        />
        {showRecorder && (
          <ScreenRecording
            downloadRecordingPath="Screen_Recording_Demo"
            downloadRecordingType="mp4"
            emailToSupport="support@xyz.com"
            isPopupOpen={isPopupOpen}
            setIsPopupOpen={setIsPopupOpen}
            startRecord={handleStartRecording}
            stopRecord={handleStopRecording}
            mediaBlobUrl={mediaBlobUrl}
            status={status}
          ></ScreenRecording>
        )}
        {on && (
          <>
            <div
              className="crosshairs"
              style={{ left: crossHairsLeft + "px", top: crossHairsTop + "px" }}
            />
            <div
              className={`overlay ${isMouseDown && "highlighting"}`}
              style={{ borderWidth }}
            />
          </>
        )}
      </>
    </div>
  );
};

export default JiraReportComponent;
